<script lang="ts">
    import { APIHelper } from "../../code/APIHelper";
    import DBG from "../../code/DBG";

    import Helpers from "../../code/Helpers";
    import ContactSupport from "../Generic/ContactSupport.svelte";

    let status = "&nbsp;";

    let user: string;
    let password: string;

    function validateFields() {
        if (!user || !password) {
            status = "ERROR: both email and password are required";
            return false;
        }
        if (!Helpers.EmailCorrect(user)) {
            status = "ERROR: email address incorrect";
            return false;
        }
        if (password.length < 8) {
            status = "ERROR: password must be at least 8 characters long";
            return false;
        }
        return true;
    }

    function submit() {
        status = "Sending...";
        if (!validateFields()) {
            return;
        }
        Helpers.HashString(password).then((pass) => {
            APIHelper.callApiEntry({
                op: "login",
                user: user,
                passHash: pass,
            })
                .then((res) => {
                    DBG.log("IdentityLogin - submit - login", res);
                    status = "DONE";
                })
                .catch((reason) => {
                    DBG.log("IdentityLogin - submit - login failed", reason);
                    status = "FAIL";
                });
        });
    }

    function keydown(evt) {
        DBG.log("IdentityLogin - keydown", evt);
        if (evt.code == "Enter") {
            submit();
        }
    }
</script>

<div>
    {#if status == "DONE"}
        <div class="completed">
            <p><i class="fa fa-check" /> Excellent, you are now logged in.</p>

            <p>
                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={() => {
                        window.location.href = "/";
                    }}>Continue</button
                >
            </p>
        </div>
    {:else if status == "FAIL"}
        <div class="failed">
            <p>
                <i class="fa fa-times-circle" /> The email and password don't match
                to a licence in our records.
            </p>
            <p>
                <ContactSupport />
            </p>
            <button
                type="button"
                class="btn btn-primary"
                on:click={() => {
                    status = "&nbsp;";
                }}>Try again</button
            >
        </div>
    {:else}
        <div class="form-floating mb-3">
            <input
                type="text"
                class="form-control"
                id="userEmail"
                placeholder="John Doe"
                bind:value={user}
            /> <label for="form">Email</label>
        </div>
        <div class="form-floating mb-3">
            <input
                type="password"
                class="form-control"
                id="userPassword"
                placeholder="password"
                bind:value={password}
                on:keydown={keydown}
            /> <label for="form">Password</label>
        </div>

        <button type="button" class="btn btn-primary" on:click={submit}
            >Submit</button
        >
        <div class="status">
            {@html status}
        </div>
    {/if}
</div>

<style>
    .completed i {
        color: green;
    }
    .failed i {
        color: #ec008c;
    }
</style>
